import React, { useState } from 'react'
import { Accordion } from 'react-bootstrap'
import { groupDetailApi } from '../../../../services/groups';
import { toastMessage } from '../../../../utils/toastMessage';
import { fetchSidebarListApi } from '../../../../services/categories';

const ChildGroup = ({ data, ind, setGroupDetail }) => {
    // console.log('data parent ChildGroup', data)
    const [childGroup, setChildGroup] = useState([])
    // console.log('childGroup', childGroup)
    const getGroupDetail = async (_id) => {
        try {
            const { data } = await groupDetailApi({ _id });
            const { success, message, data: response } = data;

            if (success) {
                setGroupDetail(response);
                // console.log(response, "Get Parents Ids");
            } else {
                toastMessage(message, "error", "getGroupDetail");
            }
        } catch (e) {
            console.log("Error:-", e.message);
        }
    };

    const getSideBarList = async (_id) => {
        try {
            const { data } = await fetchSidebarListApi({ _id });
            const { success, message, data: response } = data;
            // console.log('response', response)
            if (success) {
                setChildGroup(response);
            } else {
                toastMessage(message, "error", "getGroupDetail");
            }
        } catch (e) {
            console.log("Error:-", e.message);
        }
    };


    const handleAccordionClick = () => {
        if (data?._id) {
            getGroupDetail(data._id);
            getSideBarList(data._id);
        } else {
            console.log("Missing data._id");
        }
    };
    return (
        // <Accordion >
        //     <Accordion.Item eventKey={ind.toString()}>
        //         <Accordion.Header onClick={handleAccordionClick} >{data?.name || "Untitled"}</Accordion.Header>
        //         {data.categoryName && <span className="sporttitle">{data.categoryName}</span>}
        //         {data.type && (
        //             <span className="sporttitle_two">{data.type}</span>
        //         )}
        //         <Accordion.Body>
        //             {childGroup.length > 0 && <ChildGroup data={childGroup} ind={ind} />}
        //         </Accordion.Body>
        //     </Accordion.Item>
        // </Accordion >
        <Accordion>
            <Accordion.Item eventKey={ind.toString()}>
                <Accordion.Header onClick={handleAccordionClick}>
                    {data?.name || "Untitled"}
                </Accordion.Header>

                <div className="tags_wrapss">
                {data?.categoryName && <span className="sporttitle">{data.categoryName}</span>}
                {data?.type && <span className="sporttitle_two">{data.type}</span>}
                </div>

                {childGroup.length > 0 && (
                    <Accordion.Body>
                        {childGroup.map((child, index) => (
                            <ChildGroup
                                key={child._id || index}
                                data={child}
                                ind={`${ind}-${index}`}
                                setGroupDetail={setGroupDetail}
                            />
                        ))}
                    </Accordion.Body>
                )}
            </Accordion.Item>
        </Accordion>
    )
}

export default ChildGroup